import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import {
  Badge, Box,
  Divider,
  Tab,
  Tabs,
  Typography,
} from '@mui/material'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { motion } from 'motion/react'
import { selectNotification } from '../../../../redux/features/notifications/notificationCenter/notificationCenterSlice';
import NotificationModal from './NotificationPopUp'
import UseTranslation from '../../../../hooks/UseTranslation';
import CenterBell from './CenterBell';
import InboxBell from './InboxBell';
import { selectNotificationInbox } from '../../../../redux/features/notifications/notificationInbox/notificationInboxSlice';
import { bellVariants } from '../../../../utils/animation'

const Index = () => {
  const notificationCenterStore = useSelector(selectNotification)
  const notificationInboxStore = useSelector(selectNotificationInbox)
  const { t } = UseTranslation()
  const [currentTab, setCurrentTab] = useState(0)

  const handleTabChange = (_, newValue) => {
    setCurrentTab(newValue)
  }
  const hasNotifications = (notificationCenterStore?.notificationsBell?.today?.length > 0) ||
  (notificationInboxStore?.notificationsBell?.today?.length > 0)

  return (
    <Box sx={styles.root}>
       <NotificationModal
        customBtnIcon={(
          <Badge
            color="error"
            variant="dot"
            sx={styles.badge(hasNotifications)}
          >
            <NotificationsNoneOutlinedIcon
              component={motion.svg}
              variants={bellVariants}
              whileHover="hover"
            />
          </Badge>
        )}
        customStyle={styles.sideBtn}
        preventClosePopUp={() => { }}
      >
        <Box sx={styles.sideButtonContainer}>
          <Typography sx={styles.headerText}>
            {t?.['Notification Center']}
          </Typography>
          <Divider sx={styles.divider} />
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            sx={styles.tabs}
            aria-label="wrapped label tabs example"
          >
            <Tab
              label={t?.Notifications}
              sx={[styles.tab(currentTab === 0)]}
            />
            <Tab
              label={t?.Inbox}
              sx={[styles.tab(currentTab === 1)]}
            />
          </Tabs>
          <Divider sx={styles.divider} />

          {currentTab === 0 && (<CenterBell />)}
          {currentTab === 1 && (<InboxBell />)}

        </Box>
      </NotificationModal>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 0,

    '& svg:nth-child(1)': {
      fontSize: '30px',
      cursor: 'pointer',
      mb: { xs: '8px', sm: '0px' },
    },

    '& svg': {
      color: 'white',
    },
  },
  sideBtn: {
    border: '0',
    color: 'text.hint',
    padding: '0',
    borderRadius: '50%',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },
  badge: (hasNotifications) => ({
    '& .MuiBadge-overlapRectangular.MuiBadge-colorError ': {
      display: hasNotifications ? 'inline-flex' : 'none',
      transform: 'scale(1) translate(-50%, 30%)',
    },
  }),

  headerText: {
    padding: '10px 5px',
    fontSize: '14px',
    fontWeight: 700,
  },
  sideButtonContainer: {
    width: { xs: '297px', sm: '470px !important' },
    maxHeight: { xs: '550px', sm: '600px' },
    minHeight: { xs: '400px', sm: '540px !important' },
    overflow: 'hidden',
  },
  tabs: {
    '& .MuiTabs-indicator': {
      width: '0px !important',
    },
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      my: '5px',
    },
  },
  tab: (isSelected) => ({
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: isSelected ? 700 : 400,
  }),

  divider: {
    margin: '0px -15px 0px -15px',
  },

}

export default Index
